var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.mainCategories, _vm.classDevice(_vm.$style)]},_vm._l((_vm.visibleCategories),function(item,index){return _c('component-category-item',{key:index,attrs:{"small":_vm.$device.isMobileOrTablet,"item":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }